import {
  Tooltip,
  Switch,
  Pagination,
  Input,
  Form,
  Empty,
  Select,
  Button,
} from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import SortingArrow from "../../../../Common/SortingArrow";
import ConfirmationModal from "../../../../Modal/ConfirmationModal";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import { changeLoader } from "../../../../redux/reducers/loader";
import {
  paginationLimit,
  paginationPages,
} from "../../../../utils/helper/constants";
import { useDispatch } from "react-redux";
import * as Validation from "../../../../utils/helper/validation";
import * as Apis from "../../../../utils/helper/enum";
import {
  capitalizeName,
  checkPermissionAction,
  formatDateFunction,
} from "../../../../utils/helper/utils";
import { usePersistentFilters } from "../../../../Hooks/commonApiHooks/usePersistentFilters";
let timer = null;
const selectStatus = [
  {
    value: "",
    label: "All",
  },
  {
    value: "active",
    label: "Active",
  },
  {
    value: "inactive",
    label: "Inactive",
  },
];
const CustomQuestionType = ({ permissionJson = [] }) => {
  const location = useLocation();
  const [form] = Form.useForm();
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [itemData, setItemData] = useState(0);
  const [allVendor, setAllVendor] = useState([]);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_MODIFIERES?.UPDATE_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Modifiers deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllModifiers();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllModifiers = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        for_custom: 1,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_MODIFIERES.GET_ALL_MODIFIERS,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllModifiers();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_MODIFIERES?.UPDATE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Modifier active successfully";
        if (item.status === "active") msg = "Modifier inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllModifiers();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllVendor = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_MODIFIERES.GET_ALL_VENDOR_LIST,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        apiResponse.data = [
          { id: "", vendorDetail: { storeName: "All" } },
          ...apiResponse.data,
        ];
        let data = apiResponse?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.vendorDetail?.storeName,
          };
        });
        setAllVendor(data);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getAllVendor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  usePersistentFilters({
      form,
      location,
      currentPath: "/manage-modifiers",
      addPath: "/add-modifiers",
      editPathPrefix: "/edit-modifiers/",
      storageKey: "modifire_filters",
      inputData,
      setInputData,
      paginationModel,
      setPaginationModel,
    });
  return (
    <>
      <div className="flex justify-end	mb-3 gap-3">
        <Search
          placeholder="Search by Modifier Name, Group Name, vendor"
          onChange={(e) => {
            let value = Validation.strFormat(e.target.value, "trim");
            form.setFieldValue("search", value);
            setInputData((prev) => ({ ...prev, search: value }));
            setPaginationModel((prev) => ({ ...prev, page: 1 }));
          }}
          style={{
            width: 350,
          }}
          className="mx-1.5 cursor-pointer"
        />
        <Select
          style={{
            width: 200,
          }}
          placeholder="Vendor"
          options={allVendor}
          showSearch
          filterOption={(input, allVendor) =>
            (allVendor?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          onChange={(e) => {
            form.setFieldValue("vendor", e);
            setInputData((prev) => ({ ...prev, vendor: e }));
            setPaginationModel((prev) => ({ ...prev, page: 1 }));
          }}
          className="mx-1.5 cursor-pointer"
        />
        <Select
          style={{
            width: 100,
          }}
          onChange={(e) => {
            form.setFieldValue("status", e);
            setInputData((prev) => ({ ...prev, status: e }));
            setPaginationModel((prev) => ({ ...prev, page: 1 }));
          }}
          placeholder="Status"
          options={selectStatus}
          showSearch
          filterOption={(input, selectStatus) =>
            (selectStatus?.label ?? "")
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          className="mx-1.5 cursor-pointer"
        />

        {checkPermissionAction("Manage Modifiers", permissionJson, "add") ? (
          <Button
            type="primary"
            size={14}
            icon={<PlusOutlined />}
            className="mx-1.5 cursor-pointer"
            onClick={() => navigate("/add-modifiers")}
          >
            Add Modifier
          </Button>
        ) : null}
      </div>
      <div className="relative overflow-x-auto">
        <table className="w-full  text-left	 text-sm  text-gray-500">
          <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Modifier Group Name (EN)
                <SortingArrow
                  onSort={(order) => handleSort("name_en", order)}
                />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Modifier Group Name (AR)
                <SortingArrow
                  onSort={(order) => handleSort("name_ar", order)}
                />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Vendor
                <SortingArrow
                  onSort={(order) => handleSort("storeName", order)}
                />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Modifier type
                <SortingArrow onSort={(order) => handleSort("type", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Created Date & Time
                <SortingArrow
                  onSort={(order) => handleSort("createdAt", order)}
                />
              </th>
              <th scope="col" className="px-3 py-3">
                Status
              </th>
              <th
                scope="col"
                className="px-3 py-3 text-center whitespace-nowrap vertical-top"
              ></th>
            </tr>
          </thead>
          <tbody>
            {list?.length ? (
              list?.map((item, index) => (
                <tr className="bg-white border-b" key={index}>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {item?.name_en}
                  </td>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {item?.name_ar}
                  </td>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {capitalizeName(item?.user?.vendorDetail?.storeName)}
                  </td>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {capitalizeName(item.type)}
                  </td>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {formatDateFunction(item.createdAt, "dd-mm-yyyy", true)}
                  </td>
                  <td className="px-3 py-4 vertical-top">
                    <Switch
                      checked={item?.status === "active" ? true : false}
                      onChange={() => {
                        handleStatusChange(item);
                      }}
                      disabled={
                        !checkPermissionAction(
                          "Manage Modifiers",
                          permissionJson,
                          "update_status"
                        )
                      }
                    />
                  </td>
                  <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                    <Tooltip title="Edit">
                      <EditOutlined
                        onClick={() => {
                          if (
                            checkPermissionAction(
                              "Manage Modifiers",
                              permissionJson,
                              "edit"
                            )
                          ) {
                            navigate("/edit-modifiers/" + item.id);
                          }
                        }}
                        className={`mx-1.5 cursor-pointer ${
                          !checkPermissionAction(
                            "Manage Modifiers",
                            permissionJson,
                            "edit"
                          )
                            ? "text-gray-400 cursor-not-allowed"
                            : ""
                        }`}
                      />
                    </Tooltip>
                    <Tooltip title="Delete">
                      <DeleteOutlined
                        className={`mx-1.5 cursor-pointer ${
                          !checkPermissionAction(
                            "Manage Modifiers",
                            permissionJson,
                            "delete"
                          )
                            ? "text-gray-400 cursor-not-allowed"
                            : ""
                        }`}
                        onClick={() => {
                          if (
                            checkPermissionAction(
                              "Manage Modifiers",
                              permissionJson,
                              "delete"
                            )
                          ) {
                            setIsDeleteModalOpen(true);
                            setItemData(item);
                          }
                        }}
                      />
                    </Tooltip>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} className="text-center mt-3">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {list?.length ? (
        <div className="text-right mt-4">
          <Pagination
            defaultCurrent={1}
            total={totalRows}
            pageSizeOptions={paginationPages}
            showSizeChanger={true}
            current={paginationModel?.page}
            pageSize={paginationModel?.limit}
            onChange={(page) =>
              setPaginationModel((prev) => ({ ...prev, page: page }))
            }
            onShowSizeChange={(current, size) =>
              setPaginationModel((prev) => ({ ...prev, limit: size }))
            }
          />
        </div>
      ) : null}
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="You want to delete this Modifier."
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
    </>
  );
};
export default CustomQuestionType;
